import { httpClient } from '@shared/api'
import type { Channel, ChannelDTO, TempChannel, TempChannelDTO } from '../model/types'
import { mapChannelFromDTO, mapCreateChannelArgsToDTO, mapEditChannelArgsToDTO } from './mappers'
import type { CreateChannelArgs, DeleteChannelArgs, EditChannelArgs, GetEmployeesArgs } from './types'

export const getChannels = async (): Promise<Channel[]> => {
    const { data: result } = await httpClient.get<ChannelDTO[]>('/channels')
    return result.map(mapChannelFromDTO)
}

export const getChannel = async (id?: number): Promise<Channel> => {
    const { data: result } = await httpClient.get<ChannelDTO>(`/channels/${id}`)
    return mapChannelFromDTO(result)
}

export const getTempChannel = async (): Promise<TempChannel> => {
    const { data: result } = await httpClient.get<TempChannelDTO>(`/channels/temp-channel`)
    return {
        id: result.chat_id,
        name: result.title,
        username: result.username,
        photoUrl: result.photo_url
    }
}

export const createChannel = async (data: CreateChannelArgs): Promise<Channel> => {
    const { data: result } = await httpClient.post<ChannelDTO>('/channels', mapCreateChannelArgsToDTO(data))
    return mapChannelFromDTO(result)
}

export const editChannel = async ({ id, data }: EditChannelArgs): Promise<Channel> => {
    const { data: result } = await httpClient.patch<ChannelDTO>(`/channels/${id}`, mapEditChannelArgsToDTO(data))
    return mapChannelFromDTO(result)
}

export const deleteChannel = async ({ id }: DeleteChannelArgs): Promise<void> => {
    await httpClient.delete<ChannelDTO>(`/channels/${id}`)
}

export const getEmployees = async ({ id }: GetEmployeesArgs): Promise<Blob> => {
    const { data: result } = await httpClient.get<Blob>(`/channels/${id}/unload-subscribers`, {
        responseType: 'blob'
    })
    return result
}

export const updateInfo = async ({ id }: GetEmployeesArgs): Promise<void> => {
    await httpClient.post<void>(`/channels/${id}/update-info`)
}
